export const translation = {
  // Navigation
  "nav.technology": "預製工法優勢",
  "nav.home": "首頁",
  "nav.locations": "全省服務據點",
  "nav.seminars": "自地自建講座",
  "nav.portfolio": "作品介紹",
  "nav.about": "集團品牌介紹",
  "nav.process": "服務流程與收費",
  "nav.contact": "線上諮詢",
  "nav.cta": "立即加入 LINE 諮詢",

  // Footer
  "footer.brand": "速築美宅家 Chronos Space",
  "footer.tagline": "速築之道，研質生活",
  "footer.scope": "台北｜新竹｜台中｜台南｜屏東｜全省服務",
  "footer.links": "快速連結",
  "footer.contact": "聯絡我們",
  "footer.lineId": "LINE@：@580frsef",
  "footer.lineCta": "立即加入 LINE 諮詢",
  "footer.copyright": "© 速築美宅家 Chronos Space. All rights reserved.",

  // Common
  "common.lineUrl": "https://lin.ee/OpssTIM",
  "common.readMore": "了解更多",
  "common.contactUs": "聯繫我們",

  // ==========================================
  // TECHNOLOGY PAGE
  // ==========================================

  "technology.hero.label": "預製工法優勢",
  "technology.hero.title": "預製工法 vs 傳統工法",
  "technology.hero.subtitle": "為什麼 Chronos Space 選擇預製鋼構工法？從工期、品質、耐震、節能到碳排放，全方位比較兩種建築方式的差異。",
  "technology.hero.cta1": "預約工法說明會",
  "technology.hero.cta2": "查看詳細比較",

  // ==========================================
  // HOME PAGE - 7 SECTIONS
  // ==========================================

  // --- Hero ---
  "home.hero.label": "高端鋼構住宅專家",
  "home.hero.title1": "縮短 50% 施工期",
  "home.hero.title2": "打造一站式高效淨零建築",
  "home.hero.subtitle": "速築美宅家 Chronos Space 以預製工法重新定義自地自建，整合建築設計、營造施工、室內裝修與軟裝美學，協助業主更有效率地完成理想住宅。",
  "home.hero.tag1": "最快 4 個月完成建築結構",
  "home.hero.tag2": "預製工法 × 鋼構住宅",
  "home.hero.tag3": "自地自建 × 危老重建",
  "home.hero.tag4": "室內至少低 5°C 的節能舒適體驗",
  "home.hero.ctaMain": "加入 LINE 預約基地可行性評估",
  "home.hero.ctaSecondary": "查看作品介紹",

  // --- Why Self-Build ---
  "home.why.label": "自地自建優勢",
  "home.why.title": "為什麼選擇自地自建？",
  "home.why.subtitle": "比買成屋更自由，比傳統營造更精準。",
  "home.why.card1.title": "極速完工",
  "home.why.card1.desc": "採用預製工法，縮減約 50% 施工日期，最快紀錄 4 個月完成建築結構。",
  "home.why.card2.title": "節能適居",
  "home.why.card2.desc": "高效斷熱與住宅系統設計，炎炎夏日室內至少比室外低 5°C，提升居住舒適度。",
  "home.why.card3.title": "淨零永續",
  "home.why.card3.desc": "低碳工法、節能概念與永續建築思維，協助打造更符合未來趨勢的家。",

  // --- Problems We Solve ---
  "home.problems.label": "常見問題",
  "home.problems.title": "我們能為你解決什麼問題？",
  "home.problems.card1.title": "已有土地，但不知道能不能蓋",
  "home.problems.card1.desc": "協助評估地目、建蔽率、容積率、法規限制與初步可行性。",
  "home.problems.card2.title": "想蓋自己的家，但不知道預算怎麼抓",
  "home.problems.card2.desc": "協助釐清營建費、設計費、室裝費、貸款與預備金。",
  "home.problems.card3.title": "擔心傳統工程拖太久、變更太多",
  "home.problems.card3.desc": "以流程管理、工項拆解與預製工法降低不確定性。",
  "home.problems.card4.title": "想要建築外觀、室內與生活風格一次整合",
  "home.problems.card4.desc": "從建築量體、室內動線到軟裝美學整體規劃。",

  // --- Service Flow ---
  "home.flow.label": "服務內容",
  "home.flow.title": "從土地評估到入住交屋，一站式完成",
  "home.flow.step1": "土地與財務評估",
  "home.flow.step2": "建築設計",
  "home.flow.step3": "預算試算",
  "home.flow.step4": "報建法規",
  "home.flow.step5": "預製工法施工",
  "home.flow.step6": "室內與軟裝",
  "home.flow.step7": "驗收交屋",

  // --- Portfolio ---
  "home.portfolio.label": "精選實績",
  "home.portfolio.title": "看見夢想宅落地的樣子",
  "home.portfolio.card1.tag": "已有土地・自地自建",
  "home.portfolio.card1.title": "自地自建夢想宅",
  "home.portfolio.card1.desc": "從土地評估到完工交屋，打造專屬於你的理想住宅。",
  "home.portfolio.card2.tag": "家族土地・多代同堂",
  "home.portfolio.card2.title": "多代同堂家族宅",
  "home.portfolio.card2.desc": "整合家族需求，規劃獨立又緊密的居住空間。",
  "home.portfolio.card3.tag": "危老重建・賣一留一",
  "home.portfolio.card3.title": "危老重建新案",
  "home.portfolio.card3.desc": "協助老舊建築重建，創造全新價值與現代生活品質。",
  "home.portfolio.cta": "查看作品",

  // --- Seminar ---
  "home.seminar.label": "免費講座",
  "home.seminar.title": "第一次自地自建，先聽懂流程再開始",
  "home.seminar.desc": "自地自建不是只找設計師畫圖，也不只是找工班施工，而是一個包含土地、法規、預算、設計、施工與時程管理的完整專案。透過說明會，你可以先掌握關鍵流程與常見風險。",
  "home.seminar.cta1": "預約講座 / 說明會",
  "home.seminar.cta2": "LINE 諮詢",

  // --- Final CTA ---
  "home.final.label": "立即開始",
  "home.final.title": "準備好開始規劃你的理想宅了嗎？",
  "home.final.desc": "無論你已有土地、正在評估危老重建，或只是想先了解預算與流程，歡迎先加入 LINE，讓我們協助你釐清第一步。",
  "home.final.cta": "加入 LINE@ 諮詢",

  // ==========================================
  // LOCATIONS PAGE
  // ==========================================

  // --- Hero ---
  "locations.hero.label": "全省服務據點",
  "locations.hero.title": "全省服務據點",
  "locations.hero.subtitle": "從北到南，陪你把土地變成理想生活空間。速築美宅家 Chronos Space 提供自地自建、危老重建、建築設計與預製工法諮詢服務。",
  "locations.hero.cta": "加入 LINE 預約諮詢",

  // --- Locations Cards ---
  "locations.card.type1": "北部服務據點",
  "locations.card.type2": "北部服務據點",
  "locations.card.type3": "設計總部",
  "locations.card.type4": "建築總部",
  "locations.card.type5": "預製工法廠",
  "locations.card.type6": "南部服務據點",
  "locations.card.type7": "南部服務據點",
  "locations.card.cta": "加入 LINE 預約",

  "locations.city.taipei": "台北",
  "locations.city.hsinchu": "新竹",
  "locations.city.taichung1": "台中",
  "locations.city.taichung2": "台中",
  "locations.city.taichung3": "台中",
  "locations.city.tainan": "台南",
  "locations.city.pingtung": "屏東",

  "locations.address.taipei": "台北市萬華區漢中街195號",
  "locations.address.hsinchu": "新竹縣竹北市自強南路372號3樓",
  "locations.address.taichung1": "台中市北區中清路一段79號6樓",
  "locations.address.taichung2": "台中市西屯區中工二路190號8樓",
  "locations.address.taichung3": "台中市南區大慶街二段55-5號",
  "locations.address.tainan": "臺南市永康區中華里中華路12號13樓之3",
  "locations.address.pingtung": "屏東縣九如鄉九清村14鄰仁愛街45巷19號1樓",

  // --- Map ---
  "locations.map.label": "選擇據點",
  "locations.map.title": "選擇離你最近的服務據點",
  "locations.map.desc": "初次諮詢可先透過 LINE@ 提供基地位置、土地狀況與需求，我們會再協助安排適合的據點或線上說明。",

  // --- Consult Scenarios ---
  "locations.scenarios.label": "諮詢情境",
  "locations.scenarios.title": "適合預約諮詢的情境",
  "locations.scenarios.card1": "已有土地，想了解能不能蓋",
  "locations.scenarios.card2": "家族土地，想規劃多代同堂住宅",
  "locations.scenarios.card3": "老屋或危老基地，想評估重建可能",
  "locations.scenarios.card4": "想了解預製工法、鋼構住宅與預算級距",

  // --- Preparation ---
  "locations.prep.label": "諮詢準備",
  "locations.prep.title": "預約前可先準備的資料",
  "locations.prep.item1": "基地地址或大約位置",
  "locations.prep.item2": "土地權狀或地號",
  "locations.prep.item3": "基地照片或現況照片",
  "locations.prep.item4": "想蓋的樓層與坪數",
  "locations.prep.item5": "家庭成員與生活需求",
  "locations.prep.item6": "預算區間與期望時程",

  // --- Distance Calculator ---
  "locations.calc.label": "距離計算",
  "locations.calc.title": "快速找到離你最近的服務據點",
  "locations.calc.subtitle": "輸入你的所在縣市或地址，自動計算與各據點的距離與預估車程。",

  // --- Final CTA ---
  "locations.final.label": "立即諮詢",
  "locations.final.title": "不確定該找哪個據點？先加入 LINE 讓我們協助你判斷",
  "locations.final.desc": "只要提供基地位置與初步需求，我們會協助你判斷適合的諮詢方式、服務據點與下一步流程。",
  "locations.final.cta": "加入 LINE@ 諮詢",

  // ==========================================
  // SEMINARS PAGE
  // ==========================================

  // --- Hero ---
  "seminars.hero.label": "免費講座",
  "seminars.hero.title": "第一次自地自建，先聽懂流程再開始",
  "seminars.hero.subtitle": "自地自建不是只找設計師畫圖，也不是只找工班施工，而是一個包含土地、法規、預算、設計、施工與時程管理的完整專案。透過說明會，先掌握關鍵流程與常見風險。",
  "seminars.hero.tag1": "免費講座",
  "seminars.hero.tag2": "120 分鐘重點解析",
  "seminars.hero.tag3": "土地 × 預算 × 法規 × 工法",
  "seminars.hero.tag4": "適合自地自建與危老重建族群",
  "seminars.hero.cta": "立即預約講座",

  // --- Problems ---
  "seminars.problems.label": "常見問題",
  "seminars.problems.title": "你是否正在遇到這些問題？",
  "seminars.problems.card1": "有土地，但不知道能不能蓋",
  "seminars.problems.card2": "不知道自地自建要準備多少預算",
  "seminars.problems.card3": "擔心報建、法規、建照流程太複雜",
  "seminars.problems.card4": "害怕工程拖延、追加預算、溝通失控",
  "seminars.problems.card5": "想蓋好房子，但不知道怎麼整合建築與室內",
  "seminars.problems.card6": "聽過預製工法，但不知道是否適合自己",

  // --- Advantages ---
  "seminars.adv.label": "核心優勢",
  "seminars.adv.title": "極速、精準、高品質",
  "seminars.adv.card1.title": "縮短 50% 工期",
  "seminars.adv.card1.desc": "工廠預製鋼骨結構，現場組裝如樂高般快速，大幅減少工期變數與等待成本。",
  "seminars.adv.card2.title": "低碳淨零工法",
  "seminars.adv.card2.desc": "符合環保永續趨勢，比傳統營造更節能、更具未來住宅價值。",
  "seminars.adv.card3.title": "涼爽恆溫設計",
  "seminars.adv.card3.desc": "高效住宅系統規劃，炎炎夏日室內溫度可比室外降低至少 5°C，提升居住舒適度。",

  // --- Speaker ---
  "seminars.speaker.label": "講師介紹",
  "seminars.speaker.name": "莊詔傑 Zhuang Zhao-jie",
  "seminars.speaker.title": "台大土木工程碩士｜16 萬粉絲影響力建築職人",
  "seminars.speaker.desc": "深耕營造與設計 15 年，曾服務於大型工程與營造領域，將土木工程的嚴謹與室內美學的感性結合，創立速築建研，協助眾多業主實現高品質的自建夢想。",
  "seminars.speaker.point1": "專業背書：台大土木工程碩士，營造實務經驗豐富。",
  "seminars.speaker.point2": "口碑證明：YouTube「莊生空間速築」累積大量粉絲追蹤。",
  "seminars.speaker.point3": "國際肯認：帶領團隊榮獲 TITAN 品牌金獎、金炬獎等肯定。",

  // --- Agenda ---
  "seminars.agenda.label": "講座議程",
  "seminars.agenda.title": "這 120 分鐘你將會學到",
  "seminars.agenda.topic1.title": "Topic 01：土地與法規可行性",
  "seminars.agenda.topic1.desc": "看懂地目、建蔽率、容積率與基地限制。",
  "seminars.agenda.topic2.title": "Topic 02：自地自建預算邏輯",
  "seminars.agenda.topic2.desc": "了解營建費、設計費、室裝費、貸款與預備金。",
  "seminars.agenda.topic3.title": "Topic 03：建築與美學設計",
  "seminars.agenda.topic3.desc": "如何把家庭成員、生活習慣、外觀風格與室內動線整合。",
  "seminars.agenda.topic4.title": "Topic 04：報建與流程控管",
  "seminars.agenda.topic4.desc": "建照、使照、施工時程與專案管理重點。",
  "seminars.agenda.topic5.title": "Topic 05：預製工法與鋼構住宅",
  "seminars.agenda.topic5.desc": "了解預製工法如何提升效率、品質與節能表現。",
  "seminars.agenda.topic6.title": "Topic 06：交屋與售後保固",
  "seminars.agenda.topic6.desc": "掌握驗收、保固與長期居住維護重點。",

  // --- Audience ---
  "seminars.audience.label": "適合對象",
  "seminars.audience.title": "適合參加的人",
  "seminars.audience.item1": "已有土地，想開始規劃自地自建的人",
  "seminars.audience.item2": "家族土地想做多代同堂住宅的人",
  "seminars.audience.item3": "正在評估危老重建、老屋重建的人",
  "seminars.audience.item4": "想了解鋼構住宅與預製工法的人",
  "seminars.audience.item5": "想先掌握預算與流程，不想盲目開始的人",
  "seminars.audience.item6": "想找一站式建築整合團隊的人",

  // --- Registration ---
  "seminars.reg.label": "預約報名",
  "seminars.reg.title": "預約講座 / 說明會",
  "seminars.reg.name": "姓名",
  "seminars.reg.phone": "手機",
  "seminars.reg.lineId": "LINE ID",
  "seminars.reg.location": "基地位置",
  "seminars.reg.need": "目前需求",
  "seminars.reg.question": "想詢問的問題",
  "seminars.reg.submit": "送出預約表單",
  "seminars.reg.lineCta": "我想先用 LINE 私訊詢問",
  "seminars.reg.success": "預約成功！我們將盡快與您聯繫確認場次與時間。",

  // --- Schedule ---
  "seminars.schedule.label": "下一場講座",
  "seminars.schedule.title": "近期講座時間表",
  "seminars.schedule.subtitle": "選擇離你最近的場次，或加入 LINE 預約其他時間與地點。",

  // --- Final CTA ---
  "seminars.final.label": "立即行動",
  "seminars.final.title": "自地自建的第一步，不是急著動工，而是先看懂全局",
  "seminars.final.cta": "加入 LINE@ 預約講座",

  // ==========================================
  // PORTFOLIO PAGE
  // ==========================================

  // --- Hero ---
  "portfolio.hero.label": "精選實績",
  "portfolio.hero.title": "看見夢想宅落地的樣子",
  "portfolio.hero.subtitle": "自地自建的過程繁瑣，但每一個成功案例，都是從「基地條件、家庭需求、預算規劃與生活想像」開始。透過作品介紹，找到與你相似的情境與參考路徑。",
  "portfolio.hero.cta": "加入 LINE@ 討論我的基地",

  // --- Categories ---
  "portfolio.filter.label": "案例情境",
  "portfolio.filter.title": "從您的情境開始搜尋",
  "portfolio.filter.subtitle": "自地自建的過程繁瑣，我們將案例依「業主痛點」分類，協助您找到參考路徑。",
  "portfolio.filter.all": "所有實績",
  "portfolio.filter.selfBuild": "已有土地・自地自建",
  "portfolio.filter.multiGen": "家族土地・多代同堂",
  "portfolio.filter.oldRebuild": "危老重建・賣一留一",
  "portfolio.filter.farm": "農地自建・景觀建築",
  "portfolio.filter.retire": "退休規劃・無障礙空間",

  // --- Cases ---
  "portfolio.case1.title": "從空地到理想宅，一次整合建築與生活機能",
  "portfolio.case1.desc": "適合已經有土地，但不確定法規、預算與建築配置的業主。透過前期評估、建築設計與室內規劃，讓基地條件轉化為可執行的住宅藍圖。",
  "portfolio.case1.point1": "土地條件盤點",
  "portfolio.case1.point2": "預算級距評估",
  "portfolio.case1.point3": "建築外觀與室內動線整合",

  "portfolio.case2.title": "讓三代同堂住得近，也住得自在",
  "portfolio.case2.desc": "針對家庭成員多、生活作息不同的基地，規劃公共空間、私領域、長輩房與收納動線，兼顧親密與隱私。",
  "portfolio.case2.point1": "多代同堂動線",
  "portfolio.case2.point2": "長輩友善空間",
  "portfolio.case2.point3": "家庭公共區域整合",

  "portfolio.case3.title": "從老屋重建到資產再配置",
  "portfolio.case3.desc": "適合老屋基地、危老重建或希望透過重建提升資產價值的業主。協助評估法規、坪效、重建可行性與未來使用方式。",
  "portfolio.case3.point1": "危老重建評估",
  "portfolio.case3.point2": "基地價值提升",
  "portfolio.case3.point3": "自住與資產配置兼顧",

  "portfolio.case4.title": "把自然景觀變成家的日常",
  "portfolio.case4.desc": "適合重視景觀、採光、戶外生活與自然環境的住宅規劃。透過建築座向、開窗、露台與室內外動線整合，創造度假感生活。",
  "portfolio.case4.point1": "景觀視野設計",
  "portfolio.case4.point2": "自然採光與通風",
  "portfolio.case4.point3": "室內外生活串聯",

  "portfolio.case5.title": "為下一階段人生預先設計",
  "portfolio.case5.desc": "適合退休宅、熟齡宅或想提早規劃長住機能的家庭。重視低維護、無障礙、收納、安全與舒適溫度控制。",
  "portfolio.case5.point1": "無障礙動線",
  "portfolio.case5.point2": "低維護材料",
  "portfolio.case5.point3": "長期居住舒適性",

  "portfolio.case6.title": "用更有效率的工法，完成更穩定的住宅品質",
  "portfolio.case6.desc": "透過預製工法與鋼構系統，提高施工效率、品質穩定度與現場管理效率，適合重視工期與品質的業主。",
  "portfolio.case6.point1": "縮短施工期",
  "portfolio.case6.point2": "提升結構穩定",
  "portfolio.case6.point3": "降低現場變數",

  "portfolio.card.cta": "預約類似案例諮詢",

  // --- Mid CTA ---
  "portfolio.mid.label": "立即諮詢",
  "portfolio.mid.title": "看到類似你的基地情境了嗎？",
  "portfolio.mid.desc": "每一塊土地都有不同的條件，每一個家庭也有不同的生活方式。歡迎先加入 LINE，提供基地位置與想法，我們協助你判斷適合的規劃方向。",
  "portfolio.mid.cta": "加入 LINE@ 諮詢我的基地",

  // --- Consult Form ---
  "portfolio.form.label": "作品諮詢",
  "portfolio.form.title": "有喜歡的案例風格嗎？歡迎留下資料",
  "portfolio.form.name": "姓名",
  "portfolio.form.phone": "手機",
  "portfolio.form.lineId": "LINE ID",
  "portfolio.form.location": "基地概況，地點 / 坪數",
  "portfolio.form.question": "目前最想實現或解決的問題",
  "portfolio.form.submit": "送出需求並預約初步評估",
  "portfolio.form.success": "需求已送出！我們將盡快與您聯繫，協助初步評估與規劃。",

  // --- Final CTA ---
  "portfolio.final.label": "立即行動",
  "portfolio.final.title": "你的夢想宅，也可以從一次初步評估開始",
  "portfolio.final.cta": "立即加入 LINE@ 諮詢",

  // ==========================================
  // ABOUT PAGE
  // ==========================================

  // --- Hero ---
  "about.hero.label": "品牌故事",
  "about.hero.title": "速築美宅家 Chronos Space",
  "about.hero.subtitle": "自地自建與危老重建的整合顧問集團。我們用極速、精準與美學，為您打造跨越時間的建築空間。",
  "about.hero.tagline": "速築之道，研質生活",
  "about.hero.cta": "預約可行性諮詢",

  // --- Core Values ---
  "about.values.label": "品牌核心",
  "about.values.title": "縮短 50% 工期，實現「速築」震撼",
  "about.values.desc": "傳統建築漫長且充滿變數。速築美宅家 Chronos Space 透過精準工廠預製與高效率現場組裝，協助業主降低時間成本與溝通風險，讓建築品質更可控。",
  "about.values.card1.title": "極速效率",
  "about.values.card1.desc": "透過預製工法與專案管理，提升施工效率，縮短等待時間。",
  "about.values.card2.title": "淨零永續",
  "about.values.card2.desc": "重視低碳、節能與未來住宅趨勢，打造更具永續價值的家。",
  "about.values.card3.title": "舒適效能",
  "about.values.card3.desc": "透過高效住宅系統與設計整合，讓居住更舒適、更節能。",

  // --- Services ---
  "about.services.label": "專業領域",
  "about.services.title": "五大專業領域，一站式服務",
  "about.services.subtitle": "我們整合建築、營造與設計，讓繁雜的自地自建變得簡單清晰。",
  "about.services.card1.title": "建築設計",
  "about.services.card1.subtitle": "唐誠設計、陳柏青建築師事務所",
  "about.services.card1.desc": "從法規、平面配置到外觀概念的完美結合。",
  "about.services.card2.title": "預製工法",
  "about.services.card2.subtitle": "瑞煦建築",
  "about.services.card2.desc": "高效預製、淨零建築的技術核心。",
  "about.services.card3.title": "營造施工",
  "about.services.card3.subtitle": "固越營造",
  "about.services.card3.desc": "專業施工、品質監造，確保結構安全，將設計藍圖精準落實。",
  "about.services.card4.title": "室內裝修",
  "about.services.card4.subtitle": "速築空間、藏風空間、大作聯合",
  "about.services.card4.desc": "結合室內美學與空間機能，創造溫暖的生活場景。",
  "about.services.card5.title": "軟裝美學",
  "about.services.card5.subtitle": "美學顧問團隊",
  "about.services.card5.desc": "由美學顧問與室內團隊整合家具、燈光、材質、色彩與生活風格。",

  // --- Team ---
  "about.team.label": "核心團隊",
  "about.team.title": "我們的團隊",

  // --- Comparison ---
  "about.compare.label": "整合優勢",
  "about.compare.title": "為什麼需要整合型團隊？",
  "about.compare.trad.title": "傳統自地自建常見問題",
  "about.compare.trad.1": "設計、建築、營造、室內分開溝通",
  "about.compare.trad.2": "預算難以控制",
  "about.compare.trad.3": "圖面與現場落差",
  "about.compare.trad.4": "時程不透明",
  "about.compare.trad.5": "追加變更多",
  "about.compare.chronos.title": "速築美宅家的整合優勢",
  "about.compare.chronos.1": "前期先釐清基地、法規與預算",
  "about.compare.chronos.2": "建築與室內同步規劃",
  "about.compare.chronos.3": "工程與設計溝通成本降低",
  "about.compare.chronos.4": "流程透明，節點清楚",
  "about.compare.chronos.5": "從外觀到入住風格一次整合",

  // --- Final CTA ---
  "about.final.label": "立即行動",
  "about.final.title": "讓專業團隊，陪你從土地走到入住",
  "about.final.desc": "自地自建不是單點服務，而是一場需要整合設計、工程、法規、預算與生活想像的長期專案。歡迎加入 LINE@，讓我們協助你釐清第一步。",
  "about.final.cta": "加入 LINE@ 預約諮詢",

  // ==========================================
  // PROCESS PAGE
  // ==========================================

  // --- Hero ---
  "process.hero.label": "透明流程",
  "process.hero.title": "自地自建流程與收費",
  "process.hero.subtitle": "從土地評估、設計規劃、預算試算、報建法規，到開工監造、室內與軟裝，我們用透明流程協助你掌握每一步。",
  "process.hero.cta": "加入 LINE@ 預約 90 分鐘說明會",

  // --- Flow Steps ---
  "process.flow.label": "完整流程",
  "process.flow.title": "自地自建 6 大服務流程",
  "process.flow.subtitle": "從「看懂土地與財務」開始，到「落成竣工入住」，每一步都有清楚的任務與對應專業團隊。",
  "process.flow.step1.title": "01 土地與財務評估",
  "process.flow.step1.desc": "確認地目、法規條件、財務結構與土建融可行性。",
  "process.flow.step2.title": "02 建築設計階段",
  "process.flow.step2.desc": "由建築師與室內設計團隊共同規劃量體、平面配置、外觀與空間藍圖。",
  "process.flow.step3.title": "03 報建與法規申請",
  "process.flow.step3.desc": "包含建照、使照與相關主管機關核准流程。",
  "process.flow.step4.title": "04 預算與工程規劃",
  "process.flow.step4.desc": "進行工項拆解、材料規格、施工估價、專案時程與風險預留。",
  "process.flow.step5.title": "05 開工監造與施工管理",
  "process.flow.step5.desc": "進行現場施工、進度控管、品質檢查與溝通協調。",
  "process.flow.step6.title": "06 室內與軟裝 / 驗收交屋",
  "process.flow.step6.desc": "完成室內裝修、軟裝配置、驗收、交屋與後續維護建議。",

  // --- Timeline ---
  "process.timeline.label": "時程規劃",
  "process.timeline.title": "服務流程 × 時程表",
  "process.timeline.note": "實際時程依基地、規模、工法、天候與主管機關審查進度有所差異，建議先透過說明會建立專案路線圖。",
  "process.timeline.phase1": "土地與財務評估",
  "process.timeline.time1": "依資料完整度與基地狀況評估",
  "process.timeline.phase2": "建築設計",
  "process.timeline.time2": "約 2–4 個月",
  "process.timeline.phase3": "報建與法規申請",
  "process.timeline.time3": "依主管機關審查進度而定",
  "process.timeline.phase4": "工程規劃與估價",
  "process.timeline.time4": "約 1–2 個月",
  "process.timeline.phase5": "開工與主體施工",
  "process.timeline.time5": "依工法、規模與基地條件而定，預製工法可有效縮短工期",
  "process.timeline.phase6": "室內與軟裝",
  "process.timeline.time6": "約 2–4 個月",

  // --- Pricing ---
  "process.pricing.label": "收費說明",
  "process.pricing.title": "收費不是先喊總價，而是先看懂需求與條件",
  "process.pricing.desc": "自地自建的費用會受到土地條件、建築規模、樓層、結構系統、材料等級、室內需求、法規限制與時程目標影響。為避免不精準報價造成誤解，我們會先透過需求盤點與基地資料評估，再提供合理的預算級距與下一階段建議。",
  "process.pricing.card1.title": "初步諮詢 / 說明會",
  "process.pricing.card1.desc": "協助釐清需求、基地條件、預算方向與流程概念。",
  "process.pricing.card2.title": "丈量 / 提案 / 可行性評估",
  "process.pricing.card2.desc": "依基地與需求進行更具體的規劃與建議，相關費用可依方案折抵後續正式設計費。",
  "process.pricing.card3.title": "正式設計與工程服務",
  "process.pricing.card3.desc": "依建築設計、室內裝修、施工管理與工程規模分階段報價與簽約。",

  // --- FAQ ---
  "process.faq.label": "常見問題",
  "process.faq.title": "常見問題 FAQ",
  "process.faq.q1": "Q1：工期多久？會不會延宕？",
  "process.faq.a1": "一般會依基地、規模、工法與審查進度而不同。我們會以關鍵路徑排程與節點管理協助控管，並在說明會中建立初步時程概念。",
  "process.faq.q2": "Q2：預算會不會越做越高？",
  "process.faq.a2": "我們會透過工項拆解、規格表與變更確認機制降低預算失控。所有變更都應先估價與簽認後再執行。",
  "process.faq.q3": "Q3：沒有完整圖面也能開始嗎？",
  "process.faq.a3": "可以。可先從說明會、需求盤點、基地條件與生活情境開始，逐步進入設計深化。",
  "process.faq.q4": "Q4：可以只做設計，不含工程嗎？",
  "process.faq.a4": "可以。設計與工程執行可分開規劃，也可依業主既有團隊條件配合。",
  "process.faq.q5": "Q5：丈量或提案費可以折抵設計費嗎？",
  "process.faq.a5": "可依實際方案規劃，若進入正式設計階段，可將部分或全部費用折抵正式設計費，實際以合約內容為準。",
  "process.faq.q6": "Q6：為何坪數相同，費用卻不同？",
  "process.faq.a6": "居住需求、基地條件、結構系統、材料等級、工法細節與室內規劃深度都會影響費用。",

  // --- Final CTA ---
  "process.final.label": "立即行動",
  "process.final.title": "想更清楚你的專屬時程與費用？",
  "process.final.desc": "預約 90 分鐘說明會，提供基地位置、手稿、生活截圖或初步想法，我們協助你建立可行性與預算級距建議。",
  "process.final.cta": "加入 LINE@ 預約說明會",

  // ==========================================
  // CONTACT PAGE
  // ==========================================

  // --- Hero ---
  "contact.hero.label": "專業諮詢",
  "contact.hero.title": "開始規劃你的自地自建第一步",
  "contact.hero.subtitle": "留下你的基地位置、預算級距、期望時程與最想實現的生活場景。我們會協助你判斷適合的諮詢方式與下一步流程。",
  "contact.hero.cta": "加入 LINE@ 快速諮詢",

  // --- Contact Info ---
  "contact.info.label": "聯絡方式",
  "contact.info.lineId": "@580frsef",
  "contact.info.lineBtn": "加入 LINE@ 諮詢",
  "contact.info.scopeTitle": "服務範圍",
  "contact.info.scope": "台北｜新竹｜台中｜台南｜屏東｜全省服務",
  "contact.info.suitableTitle": "適合詢問",
  "contact.info.suitable1": "自地自建",
  "contact.info.suitable2": "危老重建",
  "contact.info.suitable3": "基地可行性",
  "contact.info.suitable4": "預製工法",
  "contact.info.suitable5": "鋼構住宅",
  "contact.info.suitable6": "建築設計",
  "contact.info.suitable7": "室內裝修",
  "contact.info.suitable8": "預算與時程",

  // --- Form ---
  "contact.form.label": "線上諮詢",
  "contact.form.title": "填寫諮詢需求",
  "contact.form.name": "姓名",
  "contact.form.phone": "手機",
  "contact.form.email": "Email",
  "contact.form.lineId": "LINE ID",
  "contact.form.location": "基地位置 / 縣市",
  "contact.form.landStatus": "土地狀態",
  "contact.form.landOption1": "已有土地",
  "contact.form.landOption2": "家族土地",
  "contact.form.landOption3": "老屋 / 危老重建",
  "contact.form.landOption4": "正在找土地",
  "contact.form.landOption5": "其他",
  "contact.form.budget": "預算級距",
  "contact.form.budgetOption1": "尚未確定",
  "contact.form.budgetOption2": "1000 萬以下",
  "contact.form.budgetOption3": "1000–2000 萬",
  "contact.form.budgetOption4": "2000–3000 萬",
  "contact.form.budgetOption5": "3000 萬以上",
  "contact.form.timeline": "預計啟動時間",
  "contact.form.timelineOption1": "越快越好",
  "contact.form.timelineOption2": "3 個月內",
  "contact.form.timelineOption3": "半年內",
  "contact.form.timelineOption4": "一年內",
  "contact.form.timelineOption5": "先了解流程",
  "contact.form.description": "需求說明",
  "contact.form.descriptionPlaceholder": "請描述你的基地狀況、家庭成員、想蓋的樓層、預算想法或目前最擔心的問題。",
  "contact.form.submit": "送出諮詢需求",
  "contact.form.success": "諮詢需求已送出！我們將盡快與您聯繫。",
  "contact.form.lineTip": "若你希望更快獲得回覆，建議直接加入 LINE@ 並傳送基地位置與需求截圖。",

  // --- Preparation ---
  "contact.prep.label": "諮詢準備",
  "contact.prep.title": "預約前可以先準備這些資料",
  "contact.prep.item1": "基地地址或地號",
  "contact.prep.item2": "土地權狀或謄本",
  "contact.prep.item3": "基地現況照片",
  "contact.prep.item4": "想蓋的樓層與坪數",
  "contact.prep.item5": "家庭成員與生活需求",
  "contact.prep.item6": "預算區間",
  "contact.prep.item7": "喜歡的建築或室內風格圖片",
  "contact.prep.item8": "希望完工或入住的時間",

  // --- FAQ ---
  "contact.faq.label": "常見問題",
  "contact.faq.title": "常見諮詢問題",
  "contact.faq.q1": "我還沒有土地，可以諮詢嗎？",
  "contact.faq.a1": "可以。你可以先了解預算、流程與選地時要注意的條件。",
  "contact.faq.q2": "只有地號，還沒有想法，可以諮詢嗎？",
  "contact.faq.a2": "可以。可先從基地條件與家庭需求開始，協助釐清可能方向。",
  "contact.faq.q3": "可以先線上諮詢嗎？",
  "contact.faq.a3": "可以。可先透過 LINE@ 提供資料，再視情況安排線上或實體說明。",
  "contact.faq.q4": "多久會回覆？",
  "contact.faq.a4": "我們會依來訊順序回覆，建議直接加入 LINE@，方便後續傳送圖片與資料。",
  "contact.faq.q5": "諮詢需要費用嗎？",
  "contact.faq.a5": "初次諮詢與說明會為免費服務。若需進行基地丈量、可行性報告或正式設計，將依方案報價。",

  // --- Final CTA ---
  "contact.final.label": "立即行動",
  "contact.final.title": "有土地、有想法，或只是想先問問，都可以從 LINE 開始",
  "contact.final.desc": "自地自建是一個長期且重要的決定，先把問題問清楚，比急著開始更重要。",
  "contact.final.cta": "加入 LINE@：@580frsef",
};